import React from "react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h5 className="text-white font-semibold text-lg mb-4">Plexys</h5>
            <p className="text-sm text-gray-400">
              Intelligent referral management and market analysis for
              healthcare providers.
            </p>
          </div>
          <div>
            <h6 className="text-white font-semibold mb-4">Product</h6>
            <ul className="space-y-2 text-sm">
              <li>
                <span
                  onClick={() => navigate("/refer/dashboard")}
                  className="cursor-pointer hover:text-white"
                >
                  Dashboard
                </span>
              </li>
              <li>
                <span
                  onClick={() => navigate("/refer/radar")}
                  className="cursor-pointer hover:text-white"
                >
                  Market Radar
                </span>
              </li>
              <li>
                <span
                  onClick={() => navigate("/refer/dashboard")}
                  className="cursor-pointer hover:text-white"
                >
                  Analytics
                </span>
              </li>
            </ul>
          </div>
          <div>
            <h6 className="text-white font-semibold mb-4">Company</h6>
            <ul className="space-y-2 text-sm">
              <li>
                <span
                  onClick={() => navigate("/refer/register")}
                  className="cursor-pointer hover:text-white"
                >
                  Get Started
                </span>
              </li>
              <li>
                <span
                  onClick={() => navigate("/refer/login")}
                  className="cursor-pointer hover:text-white"
                >
                  Sign In
                </span>
              </li>
            </ul>
          </div>
          <div>
            <h6 className="text-white font-semibold mb-4">Legal</h6>
            <ul className="space-y-2 text-sm">
              <li>
                <span
                  onClick={() => navigate("/privacy-policy")}
                  className="cursor-pointer hover:text-white"
                >
                  Privacy Policy
                </span>
              </li>
              <li>
                <span
                  onClick={() => navigate("/terms-of-service")}
                  className="cursor-pointer hover:text-white"
                >
                  Terms of Service
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} Plexys Limited. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
